  $(document).ready(function() {
    let $menu = $('.menu');
    let $mobileSubmenuOverlay = $('.mobile-submenu-overlay');
    let $mobileMenuTrigger = $('.mobile-menu-trigger');
    let $mobileMenuClose = $('.mobile-menu-close');

    // Function to show the mobile menu
    function showMobileMenu() {
      $menu.addClass('active').show();
    }

    // Function to hide the mobile menu
    function hideMobileMenu() {
      $menu.removeClass('active').hide();
      hideMobileSubmenuOverlay(); // Hide mobile sub-menu overlay when closing the menu
    }

    // Function to show the mobile submenu overlay
    function showMobileSubmenuOverlay() {
      $mobileSubmenuOverlay.show();
    }

    // Function to hide the mobile submenu overlay
    function hideMobileSubmenuOverlay() {
      $mobileSubmenuOverlay.hide();
    }

    // Toggle mobile submenu overlay and sub-menus when the menu with children is clicked
    $menu.on('click', '.menu-item-has-children > a', function(event) {
      if (window.matchMedia("(min-width: 1050px)").matches) return;
      event.preventDefault();
      let $parentMenuItem = $(this).parent();
      let clickedParentTitle =  $('.menu-item-has-children > a ').text();
      let $menuChildItem = $('.header .menu>ul>li .sub-menu.mega-menu');
      console.log("kuygj");
      $parentMenuItem.toggleClass('active');
      if ($parentMenuItem.hasClass('active')) {
        $menuChildItem.css('display', 'block');
        $('.current-menu-title').text(clickedParentTitle);

        $('.go-back').css('display', 'block');
        $('.go-back').on('click', function(){
          $menuChildItem.css('display', 'none');
          $('.go-back').css('display', 'none')
          $('.current-menu-title').css('display', 'none');
        })
      }
    });

    // Toggle mobile menu when the trigger is clicked
    $mobileMenuTrigger.on('click', showMobileMenu);

    // Close the mobile menu when the close button or overlay is clicked
    $mobileMenuClose.on('click', hideMobileMenu);

    // Window breakpoints
    function checkWindowSize() {
      let isSmallScreen = $(window).width() < 1050;
      $menu[isSmallScreen ? 'hide' : 'show']();
      if (!isSmallScreen) {
        // Ensure that sub-menus are hidden when the screen size is not small
        $menu.find('.menu-item-has-children').removeClass('active');
        hideMobileSubmenuOverlay();
      }
    }

    // Initial check and listen for window resize
    checkWindowSize();
    $(window).resize(checkWindowSize);
  });


window.onscroll = function(e) {
  if (this.oldScroll > this.scrollY){
    $('header').css('top','0'); 
    $('header').addClass('scrolled-up');
    
  } else {
    $('header').css('top','-120px');
    $('header').removeClass('scrolled-up');
    
  } 
this.oldScroll = this.scrollY;
}


   


